export class ChangeGuestListItemArrivalStateCommand {
  constructor(arrivalState, rejectionNote) {
    //rejectionNote only set if state is rejected
    this.arrivalState = arrivalState;
    this.rejectionNote = rejectionNote;
  }
}
